import { Col, Row } from 'reactstrap';
import { clx } from 'Utils';
import { Card } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';

// Inline skeleton style
const skeletonStyle: React.CSSProperties = {
	minHeight: '20px',
	width: '100px'
};

export const SkeletonCredit: FC = () => {
	return (
		<Col>
			<Card className="h-100">
				<h6
					className={clx(
						styles.row,
						'd-flex align-items-center justify-content-between text-gray-3 fs-6 fw-400'
					)}>
					<span className={styles.rowLabel}>
						{' '}
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<div className="d-flex align-items-center gap-2">
						<span className="skeletonStyle" style={skeletonStyle} />
						<span className="skeletonStyle" style={skeletonStyle} />
					</div>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span className="fs-6">
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={clx(styles.rowLabel, 'fw-500')}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<div className="d-flex align-items-center text-end">
								<span className="fs-6 fw-500">
									<span
										className="skeletonStyle"
										style={skeletonStyle}
									/>
								</span>
								<span className="text-gray-3 ms-2 fs-small">
									<span
										className="skeletonStyle"
										style={skeletonStyle}
									/>
								</span>
							</div>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
